import React, { useState } from 'react';
import Select from 'components/Atom/Select';
import DateRangePicker from 'components/Atom/DateRange';
import { Button } from 'components/Atom/Button';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { BanksName } from 'utils/services';
import './style.css';
import { Button as ANTDButton, Form, notification } from 'antd';
import { paymentType } from 'utils/constant';
const Filter = ({ filtersData, handleClose, onSearch, filterToggler }) => {
  const store = useSelector((state) => state.company.store);
  const [filterData, setFilterData] = useState(filtersData);
  const handleOnChangeValue = (e, type) => {
    if (e === null || e === 'all') {
      setFilterData((prevState) => {
        const newState = { ...prevState };
        delete newState[type];
        return newState;
      });
    } else {
      setFilterData((pre) => ({ ...pre, [type]: e }));
    }
  };
  const handleResetFilter = () => {
    onSearch(null);
    handleClose();
  };
  const handleApplyFilters = () => {
    if (Object.keys(filterData ?? {})?.length > 0 || (Object.keys(filterData ?? {})?.length === 0 && Object.keys(filtersData ?? {})?.length > 0)) {
      onSearch(filterData);
      handleClose();
    } else {
      notification.warning({ message: 'At least one filter is required', placement: 'bottomRight' });
    }
  };
  const options = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'FAILED',
      value: 'failed',
    },
    {
      label: 'REFUNDED',
      value: 'refunded',
    },
    {
      label: 'SUCCEEDED',
      value: 'succeeded',
    },
    {
      label: 'CANCELLED',
      value: 'canceled',
    },
    {
      label: 'PROCESSING',
      value: 'processing',
    },
    {
      label: 'REQUIRES ACTION',
      value: 'requires_action',
    },
    {
      label: 'REQUIRES CAPTURE',
      value: 'requires_capture',
    },
    {
      label: 'PARTIALLY REFUNDED',
      value: 'partially_refunded',
    },
    {
      label: 'REQUIRES CONFIRMATION',
      value: 'requires_confirmation',
    },
    {
      label: 'REQUIRES PAYMENT METHOD',
      value: 'requires_payment_method',
    },
    {
      label: 'VOIDED',
      value: 'voided',
    },
  ];
  const binsOptions = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'APPLIED',
      value: 'APPLIED',
    },
    {
      label: 'NOT APPLIED',
      value: 'NOT_APPLIED',
    },
  ];
  return (
    <div style={{ width: '100%', marginTop: '1rem', marginBottom: '0.75rem' }}>
      <Form layout='vertical'>
        <div className='custom-child transaction-filter' style={{ flexWrap: 'wrap', gap: '0', columnGap: '1.56rem' }}>
          <div>
            <Form.Item className='font-bold' label='Intent Status:'>
              <Select defaultValue={filtersData?.intent_status ?? options[0]} optionsValue={options} handleChange={(e) => handleOnChangeValue(e.value, 'intent_status')} style={{ width: '100%' }} />
            </Form.Item>
          </div>
          <div>
            <Form.Item className='font-bold' label='Payment Method:'>
              <Select
                defaultValue={filtersData?.paymentType ?? paymentType[0]}
                optionsValue={paymentType}
                handleChange={(e) => handleOnChangeValue(e.value, 'paymentType')}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item className='font-bold' label='Gateway Type:'>
              <Select
                defaultValue={filterData?.gatewayType ?? 'all'}
                optionsValue={[{ label: 'All', value: 'all' }, ...BanksName]}
                handleChange={(e) => handleOnChangeValue(e.value, 'gatewayType')}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div className='-mt-[8px]'>
            <Form.Item name='date' className='modalField font-bold' label='Date Range:'>
              <DateRangePicker
                defaultValue={filtersData?.date_range ? [moment(filtersData?.date_range[0]), moment(filtersData?.date_range[1])] : null}
                value={[filterData?.date_range]}
                hideButton={true}
                onChange={(e) => handleOnChangeValue(e, 'date_range')}
              />
            </Form.Item>
          </div>
        </div>
        <div className='binClass mt-1'>
          <div className='float-start filter-btn'>
            <Button
              onClick={() => {
                handleApplyFilters();
                filterToggler();
              }}>
              Apply
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Filter;
